import { resolveStudentTabDestination } from "./studentTabRouting";

/**
 * Builds the student sidebar href for a course tab label, opening the matching content directly.
 * @param {string} tabLabel
 * @param {import("./studentTabRouting").StudentTabRouteHints} [hints]
 * @returns {string}
 */
export function buildStudentTabHref(tabLabel, hints) {
  const { routeSlug, pestana } = resolveStudentTabDestination(tabLabel, hints);
  const basePath = `/usuario/${routeSlug}`;
  if (pestana.length > 0) {
    return `${basePath}?pestana=${encodeURIComponent(pestana)}`;
  }
  return basePath;
}

/**
 * @param {string} pathname
 * @param {string} search
 * @param {string} tabLabel
 * @param {import("./studentTabRouting").StudentTabRouteHints} [hints]
 * @returns {boolean}
 */
export function isStudentSidebarTabActive(pathname, search, tabLabel, hints) {
  const label = typeof tabLabel === "string" ? tabLabel.trim() : "";
  if (label.length === 0) {
    return false;
  }

  const { routeSlug, pestana } = resolveStudentTabDestination(label, hints);
  const path = typeof pathname === "string" ? pathname : "";
  const onRoute = path === `/usuario/${routeSlug}` || path.startsWith(`/usuario/${routeSlug}/`);
  if (!onRoute) {
    return false;
  }

  const params = new URLSearchParams(typeof search === "string" ? search : "");
  const currentPestana = params.get("pestana") || "";
  return currentPestana === pestana;
}
